export default __webpack_public_path__ + "static/media/faq-header-image.83bdee25.png";